/* Progressive reveal for Coolpo page sections.

   Content is VISIBLE BY DEFAULT. This script is the only thing that can hide it,
   and it only ever hides in order to animate straight back in. If the script
   never runs — no JS, an older browser, a crawler, a background tab that never
   paints, or an earlier script throwing — then `.wf-reveal-on` is never added,
   the CSS hiding rule never matches, and every section simply shows.

   This is the whole point. A conventionally-gated reveal (hidden in CSS, shown
   by a class) ships the section blank in exactly those cases, which on a
   storefront costs revenue and indexing.

   See plans/004-reveal-mechanism-ngo-steps.md. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var STAGGER = 60;   /* ms between siblings — audit band is 30-80ms */
  var CAP     = 240;  /* ms — past ~4 items the tail should not keep sliding */

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);   /* reveal once; never replay on scroll back */
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });

  var groups = document.querySelectorAll('[data-wf-reveal]');
  Array.prototype.forEach.call(groups, function (group) {
    var items = group.querySelectorAll('[data-wf-reveal-item]');
    if (!items.length) return;
    group.classList.add('wf-reveal-on');   /* arms the hiding rule */
    Array.prototype.forEach.call(items, function (el, i) {
      el.style.transitionDelay = Math.min(i * STAGGER, CAP) + 'ms';
      io.observe(el);
    });
  });
})();
